import { Briefcase, DocumentEdit, Phone, UserProfile, Wallet } from '@sravni/react-icons';

import { PARTNERS_IDS } from 'constants/partners';

import { avito } from 'shared/assets';
import { FormStepId } from 'shared/config/formStepId';

export const DefaultFormIcons: Record<FormStepId, JSX.Element> = {
  [FormStepId.CreditPurposeInfo]: <Wallet />,
  [FormStepId.AdditionalInfo]: <DocumentEdit />,
  [FormStepId.ContactsInfo]: <Phone />,
  [FormStepId.PassportInfo]: <UserProfile />,
  [FormStepId.WorkplaceInfo]: <Briefcase />,
} as const;

export const FormIconConfig: Record<number, Record<FormStepId, typeof avito.DocSvg>> = {
  [PARTNERS_IDS.avito]: {
    [FormStepId.AdditionalInfo]: avito.DocSvg,
    [FormStepId.ContactsInfo]: avito.CallSvg,
    [FormStepId.CreditPurposeInfo]: avito.RubSvg,
    [FormStepId.PassportInfo]: avito.PersonSvg,
    [FormStepId.WorkplaceInfo]: avito.CaseSvg,
  },
} as const;
